const publicStore = {
    namespaced: true,
    state: {
        // 从 localStorage 恢复时要解析 JSON
        name: localStorage.getItem('routeName') || '工作台',
        userName: (() => {
            try {
                const saved = localStorage.getItem('userInfo');
                return saved ? JSON.parse(saved) : '';
            } catch (e) {
                console.error('Failed to parse userInfo from localStorage', e);
                return '';
            }
        })(),
    },
    mutations: {
        SET_NAME(state, name) {
            state.name = name;
        },
        SET_USER_NAME(state, user) {
            // 接收完整用户对象
            state.userName = user;
        },
    },
    actions: {
        setName({ commit }, name) {
            localStorage.setItem('routeName', name);
            commit('SET_NAME', name);
        },
        setUserName({ commit }, user) {
            // 正确：将对象转为字符串存储
            localStorage.setItem('userInfo', JSON.stringify(user));
            commit('SET_USER_NAME', user);
        },
        clearName({ commit }) {
            localStorage.removeItem('routeName');
            commit('SET_NAME', '工作台');
        },
        clearUserName({ commit }) {
            localStorage.removeItem('userInfo');
            commit('SET_USER_NAME', '');
        },
    },
};

export default publicStore;
